<script>
  export default {
    name: 'MobilizeV2CreateTemplates'
  }
</script>

<template>
  <div class="mobilizev2-view">
    <h1>Create Templates</h1>
    <div class="buttons">
      <v-card>
        <v-icon left size="200">subject</v-icon>
        <v-btn to="/mobilizev2/text-templates/new" color="primary" class="mini-hidden">
          <v-icon left dark>add</v-icon>
          Create text template
        </v-btn>
      </v-card>
      <v-card>
        <v-icon left size="200">photo</v-icon>
        <v-btn to="/mobilizev2/image-templates/new" color="primary" class="mini-hidden">
          <v-icon left dark>add</v-icon>
          Create image template
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  h1 {
    margin-bottom: 40px;
  }

  .buttons {
    display: flex;

    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px;

      &:first-child {
        margin-right: 5%;
      }
    }

    .mini-hidden {
      margin-top: 20px;
      width: 250px;
    }
  }
</style>
